module.exports = __webpack_public_path__ + "img/transaction.b0c823c1.svg";